<template>
  <section class="settings">
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('SETTING', 2) }) | formatTitle"></vue-headful>
    <settings-list></settings-list>

    <router-view class="settings__route"></router-view>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import SettingsList from './SettingsList'

export default {
  name: 'settings',
  components: { SettingsList }
}
</script>
